import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { smallMediaQuery, mediumMediaQuery } from '../../../common/utilities/sizeHelpers';
import { StoryCardFlatItem } from './storyCardFlatItem';

export const SubStoriesCardList = memo(({ subStories, enableSourceParameterOnStoriesLinks, source }) => {

    return(
        <Container>
            {subStories?.length > 0 && subStories.map(story => {
                return <StoryCardFlatItem
                    key={story?.NodeAlias}
                    nodeAlias={story?.NodeAlias}
                    thumbnailImageLink={story?.ThumbnailImageLink}
                    videoLink={story?.VideoLinks?.[0]?.Url}
                    storyTitle={story?.Title}
                    storyText={story?.Title}
                    enableSourceParameterOnStoriesLinks={enableSourceParameterOnStoriesLinks}
                    source={source}
                />;
            })}
        </Container>
    );
});

SubStoriesCardList.displayName = 'SubStoriesCardList';

SubStoriesCardList.propTypes = {
    subStories: PropTypes.array
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    background: #ffffff;
    height: 100%;
    width: 40%;

    @media ${mediumMediaQuery} {
        flex-direction: column;
        min-height: 560px;
        height: 560px;
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
    }

    @media ${smallMediaQuery} {
        flex-direction: column;
        height: 596px;
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
    }
`;
